import {WorldDifficultyLevel} from "./types";

import {GAME_WORLD} from "../../../Games";
import {Game} from "../../../types";
import {StringUtil} from "../../../../shared/string_util";
import {$KTS} from "../../../../shared/types";
import {MapGameFragment} from "../MapGameFragment";
import {ReactComponent as WorldMap} from "../res/world.svg";
import {Component} from "react";
import {ALL_COUNTRIES, Country} from "../types";

export class WorldGameFragment extends MapGameFragment<WorldDifficultyLevel> {

  protected getGame(): Game {
    return GAME_WORLD;
  }

  protected allCountries(): Country[] {
    return ALL_COUNTRIES;
  }

  protected getMapComponent(): typeof Component {
    //@ts-ignore
    return WorldMap;
  }

  protected getLevels(): WorldDifficultyLevel[] {
    return WorldDifficultyLevel.VALUES;
  }

  protected getResultText(): string {
    let resultText: string = "You completed %{level} game.";
    switch (this.state.gameConfig.level) {
      case WorldDifficultyLevel.EASY:
        resultText = StringUtil.format(resultText, $KTS("level", "an easy"));
        break;
      case WorldDifficultyLevel.MEDIUM:
        resultText = StringUtil.format(resultText, $KTS("level", "a medium"));
        break;
      case WorldDifficultyLevel.HARD:
        resultText = StringUtil.format(resultText, $KTS("level", "a hard"));
        break;
    }
    return resultText;
  }
}